const whatsappUrl = 'https://wa.me/905077089198?text=Merhaba%2C%20V%C4%B0AYP%C4%B0%C4%B0%20Temizlik%20i%C3%A7in%20teklif%20almak%20istiyorum.%20Temizlenecek%20alan%C4%B1n%20videosunu%20g%C3%B6ndermek%20istiyorum.';

export default function FinalCTA() {
  return (
    <section className="bg-warm-white py-16 md:py-24 lg:py-32">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-navy leading-tight mb-6">
          TEMİZLENECEK ALANI GÖSTERİN.<br />
          <span className="text-gold">GERİSİNİ BİRLİKTE PLANLAYALIM.</span>
        </h2>

        <p className="text-navy/60 text-base md:text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
          Alanınızın kısa videosunu gönderin ve ihtiyacınıza uygun profesyonel temizlik teklifinizi alın.
        </p>

        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center gap-3 px-10 py-5 bg-gold hover:bg-gold-dark text-navy-dark font-bold text-lg md:text-xl rounded-md transition-all duration-300 hover:scale-105 mb-6"
        >
          <i className="ri-whatsapp-line text-2xl"></i>
          WHATSAPP'TAN TEKLİF AL
        </a>

        <p className="text-navy/70 font-semibold text-lg md:text-xl">
          0507 708 91 98
        </p>
      </div>
    </section>
  );
}